import vue from "vue";
import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { mapToken } from "@/constants/tokens";
import { getMapParams } from "@/utils";
import { eeEditorStyles } from "@/libs/map-draw/config";
// import { getScenarioModellingTileset } from "@/libs/map-draw/config";
import { ModesController } from "@/libs/map-draw/modes/modes-controller";
import {
  ModelController,
  LayerController,
  StyleController,
  DiagramController,
  EditorController
} from "../controllers";

export const initMap = component => {
  // map creating
  const { center, zoom } = getMapParams("cMap", component.$store);
  // const theme = component.$store.state.theme;
  // const disabledTiles = theme === "dark-theme" ? "light-theme" : "dark-theme";

  mapboxgl.accessToken = mapToken;

  component.mapgl = new mapboxgl.Map({
    container: "c-map",
    // style: getScenarioModellingTileset(theme),
    style: "mapbox://styles/aplussmoscow/ckea67vfv6oxu1aoxuaikbgvm",
    center,
    zoom
  });

  // component.mapgl.on("load", () =>
  //   component.mapgl.setLayoutProperty(disabledTiles, "visibility", "none")
  // );

  // view handlers
  component.mapgl.on("pitch", e => {
    component.is3d = e.target.getPitch() !== 0;
  });
  component.mapgl.on("rotate", e => {
    component.mapBearing = e.target.getBearing();
  });

  // popup handlers
  component.mapgl.on("mousemove", e => {
    const { fullPath } = component.$route;
    if (fullPath.includes("editor")) return;

    const { activeLayers } = component.$store.state.calculations;
    const mapLayers = activeLayers.filter(l => component.mapgl.getLayer(l));
    if (!mapLayers.length) return;

    const { x, y } = e.point;
    const bbox = [[x - 5, y - 5], [x + 5, y + 5]];
    const features = component.mapgl.queryRenderedFeatures(bbox, {
      layers: mapLayers
    });

    if (!features.length) {
      component.mapgl.getCanvas().style.cursor = "";
      component.popupSettings.display = "none";
      component.popupSettings.values = [];
      return;
    }

    component.mapgl.getCanvas().style.cursor = "pointer";
    const feature = features[0];
    const { properties, layer } = feature;
    const layerId = layer.id.includes("_") ? layer.id.split("_")[0] : layer.id;
    const { stylesConfigs } = component.$store.state.calculations;
    const { fields, enabled } = stylesConfigs[layerId].popup;
    if (fields.length && enabled) {
      component.popupSettings.values = fields.map(key => ({
        key,
        value: properties[key] === "null" ? null : properties[key]
      }));
      component.popupSettings.top = y - 38;
      component.popupSettings.left = x + 10;
      component.popupSettings.display = "block";
    }
  });

  // controllers
  component.controllers.model = new ModelController(component);
  component.controllers.layers = new LayerController(component);
  component.controllers.styles = new StyleController(component);
  component.controllers.diagram = new DiagramController(component);

  // editor
  const mc = new ModesController(component, MapboxDraw, "editorState");
  component.draw = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      line_string: true,
      point: true,
      polygon: true,
      trash: true
    },
    styles: eeEditorStyles,
    userProperties: true,
    modes: Object.assign(MapboxDraw.modes, {
      simple_select: mc.createCSimpleSelectMode(),
      draw_points: mc.createCDrawPointsMode()
    })
  });

  component.controllers.editor = new EditorController(component);
  component.controllers.editor.initDrawListeners();

  component.mapgl.addControl(component.draw);

  vue.prototype.$cControllers = component.controllers;

  window.addEventListener("beforeunload", component.saveMapParams);
};
